import React, { useState } from "react";

import { useTranslation } from "react-i18next";
import { Button, Checkbox, Col, Dropdown, Input, Menu, Row, Select, Space, Switch, Table, Tooltip } from "antd";


const ManageAccount = () => {
  const { t } = useTranslation();
  const { Option } = Select;
  const [AccountData, setAccountData] = useState({
    AccountType: null,
  });

  const [disableBtn, setDisableBtn] = useState(true);

  const handleSubmit = async (e) => {};

  const handleCancel = async (e) => {
    setAccountData({
      AccountType: null,
    });
  };

  const handleOnChange = (e, isSelect, name) => {
    setDisableBtn(false);

    if (isSelect === "select") {
      setAccountData({
        ...AccountData,
        [name]: e,
      });
    } else {
      setAccountData({
        ...AccountData,
        [e.target.name]: e.target.value,
      });
    }
  };

  function onSearch(val) {}

  return (
    <React.Fragment>
      <div className="form__fields">
        <div className="col-md-12">
          <div className="row">
            <div className="col-md-12">
              <h4 className="workarea__heading mb-0">
                {" "}
                {t("Manage Account")}{" "}
              </h4>
            </div>
            <div className="col-lg-12">
              <div className="row">
                <div className="col-lg-9">
                  <div className="row">
                    <div className="col-lg-6 mt-4">
                      <div className="input__block">
                        <label>{t("Select Account type")}</label>
                        <Select
                          className="border__grey"
                          showSearch
                          placeholder={t("Choose Any")}
                          name="AccountType"
                          value={
                            AccountData.AccountType
                              ? AccountData.AccountType
                              : []
                          }
                          optionFilterProp="children"
                          onChange={(e) =>
                            handleOnChange(e, "select", "AccountType")
                          }
                          onSearch={onSearch}
                          filterOption={(input, option) =>
                            option.children
                              .toLowerCase()
                              .indexOf(input.toLowerCase()) >= 0
                          }
                        >
                          <Option value="Company 1"> {t("Company 1")} </Option>
                          <Option value="Company 1"> {t("Company 2")} </Option>
                          <Option value="Company 1"> {t("Company 3")} </Option>
                        </Select>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-6 mt-3">
                  <button
                    className={
                      disableBtn ? "disabled-btn   me-4" : "primary-btn  me-4"
                    }
                    onClick={handleSubmit}
                  >
                    {" "}
                    {t("Apply")}{" "}
                  </button>
                  <button
                    className={disableBtn ? "disabled-btn   " : "primary-btn  "}
                    onClick={handleCancel}
                  >
                    {" "}
                    {t("Cancel")}{" "}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ManageAccount;
